import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { ButtonComponent } from './components/button/button.component';
import { StepperComponent } from './components/stepper/stepper.component';

import { QuestionComponent } from './components/question/question.component';
import { HeaderComponent } from './components/header/header.component';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from './components/loader/loader.component';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { BaseComponent } from './themes/base/base.component';
import { SecondaryComponent } from './themes/secondary/secondary.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Question2Component } from './components/question2/question2.component';
import { ThemeComponent } from './components/theme/theme.component';
import { MessageComponent } from './components/message/message.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';

const appRoutes: Routes = [
  {
    path: '',
    component: AppComponent,
  },
];

@NgModule({
  declarations: [
    AppComponent,
    ButtonComponent,
    StepperComponent,
    ProgressBarComponent,
    QuestionComponent,
    HeaderComponent,
    IconButtonComponent,
    LoaderComponent,
    BaseComponent,
    SecondaryComponent,
    Question2Component,
    ThemeComponent,
    MessageComponent,
    ErrorPageComponent,
  ],
  imports: [
    BrowserModule,
    // AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
